/**
 * Non-user billing customers — `/api/v2/invoicing/customers/*`.
 * Billing-only recipients (no login, not in patient stats). An invoice bills
 * EITHER a patient OR a customer.
 */
import instance, { ADMIN_PREFIX } from 'services/api';
import {
  Customer,
  CustomerInput,
  UpdateCustomerInput
} from 'types/api/invoicing';

const BASE = `${ADMIN_PREFIX}/invoicing/customers`;

/** `GET /invoicing/customers?search=` — typeahead by name/email. */
export const fetchCustomers = async (search: string): Promise<Customer[]> => {
  const res = await instance.get<Customer[] | { data: Customer[] }>(BASE, {
    params: { search }
  });

  const body = res.data;

  return Array.isArray(body) ? body : body?.data ?? [];
};

/** `POST /invoicing/customers` — create a billing customer. */
export const createCustomer = async (
  input: CustomerInput
): Promise<Customer> => {
  const res = await instance.post<Customer>(BASE, input);

  return res.data;
};

/** `PATCH /invoicing/customers/:ref` — edit a customer (ref = id or publicId). */
export const updateCustomer = async (
  ref: string,
  input: UpdateCustomerInput
): Promise<Customer> => {
  const res = await instance.patch<Customer>(`${BASE}/${ref}`, input);

  return res.data;
};
